var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { useAppearance } from './useAppearance';
import { BaseButton } from '../../../templates/BaseButton';
import { color } from '../../../constants';
import { Dismiss } from '../../../icons';
var sizes = {
    thin: '20px',
    medium: '24px',
    thick: '32px',
    default: '32px'
};
var ButtonWrapper = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: transparent;\n  padding: 0;\n  cursor: ", " !important;\n  line-height: 0;\n\n  &:hover svg {\n    fill: ", ";\n  }\n"], ["\n  background: transparent;\n  padding: 0;\n  cursor: ", " !important;\n  line-height: 0;\n\n  &:hover svg {\n    fill: ",
    ";\n  }\n"])), function (props) { return (props.disabled ? 'not-allowed' : 'pointer'); }, function (props) {
    return props.disabled ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.8)';
});
export var Dismissable = function (_a) {
    var _b = _a.appearance, appearance = _b === void 0 ? 'solid' : _b, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, onClick = _a.onClick, children = _a.children;
    var props = __rest(useAppearance(appearance, isDisabled), []);
    var padding = size === 'thin'
        ? '0 2px 0 8px'
        : size === 'medium'
            ? '0 4px 0 8px'
            : '0 8px 0 12px';
    return (React.createElement(BaseButton, __assign({ as: "span", "$borderRadius": "16px", "$color": color.theme.typography.ink, "$height": sizes[size], "$padding": padding, after: React.createElement(ButtonWrapper, { disabled: isDisabled, onClick: onClick },
            React.createElement(Dismiss, { fillColor: "rgba(0, 0, 0, 0.5)", small: true })) }, props), children));
};
var templateObject_1;
//# sourceMappingURL=index.js.map